import { initializeApp } from "firebase/app";
import { initializeFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASEURL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENTID,
};

export const firebaseApp = initializeApp(firebaseConfig);

// Force long-polling for the Firestore transport. A buffering intermediary
// (proxy/VPN/antivirus) holds the default WebChannel stream open and delays
// onSnapshot's CURRENT marker by ~15-30s. Auto-detect's one-shot probe misses
// it, so force long-polling: each Listen response is a discrete, self-completing
// HTTP request that no intermediary can hold open.
export const firestore = initializeFirestore(firebaseApp, {
  experimentalForceLongPolling: true,
});
